import * as React from 'react';
import { findDOMNode } from 'react-dom';
import { getTranslate } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import * as Actions from '../../actions/Actions';
import * as Api from '../../Api';
import * as BasketControl from '../../BasketControl';
import { Empty } from '../../BasketControl';
import * as Routes from '../../Routes';
import * as Store from '../../Store';
import { Utilities } from '../../Utilities';
import Menu from '../Menu';
import { MainLayout } from '../MainLayout/MainLayout';

interface RouteParams
  extends RouteComponentProps<
    {
      vrid: number;
    },
    {}
  > {}

type Props = RouteParams &
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps>;

class MenuContainer extends React.Component<Props, {}> {
  private handleClickItem = () => {
    Utilities.navigateTo('/where');
  };

  public componentDidMount() {
    Utilities.ensureVisible(findDOMNode(this));
  }

  public UNSAFE_componentWillReceiveProps(newProps: Props) {
    //For loading restaurant once RestaurantSummaries have loaded
    if (
      newProps.CollectionSummaries != this.props.CollectionSummaries ||
      newProps.DeliverySummaries != this.props.DeliverySummaries
    ) {
      this.props.LoadRestaurant(this.props);
    }
  }

  /**
   * THIS IS WRONG - searches for menu based on vrId and always resolves first Collection and then Delivery
   */
  private findMenu = (): Api.MenuReposnse | null => {
    const menuExists = (Summaries: Api.RestaurantSummaryCommon[]): Api.MenuReposnse => {
      const versionIndex = Summaries.findIndex(
        (Summary) => Summary.VirtualRestaurantId === parseInt(this.props.params.vrid as any)
      );

      if (versionIndex === -1) {
        return null;
      }

      const menuUrl = Summaries[versionIndex].MenuUrl;

      if (!menuUrl) {
        return null;
      }

      const menu = { ...this.props.MenuData[menuUrl] };

      if (!menu) {
        return null;
      }

      switch (menu.status) {
        case 'pending':
        case 'none':
          return null;
        case 'success':
          menu.data.MenuUrl = menuUrl;
          return menu.data;
      }
    };

    if (!this.props.params.vrid) {
      return null;
    }

    const deliverySummaries = this.props.DeliverySummaries as any;

    if (this.props.CollectionSummaries.status != 'success') {
      return null;
    }
    let menu = null;
    if (this.props.CollectionSummaries.data.length > 0) {
      menu = menuExists(this.props.CollectionSummaries.data);
    }
    if (
      !menu &&
      this.props.DeliverySummaries.status === 'success' &&
      deliverySummaries.data.length > 0
    ) {
      menu = menuExists(deliverySummaries.data);
    }
    return menu;
  };

  private handleAddItem = (payload: BasketControl.Item) => {
    this.props.AddItemToBasket(payload);
  };

  private handleRemoveItem = (payload: { menuId: number; index: number; indexName?: string }) => {
    this.props.AddToast(this.props.translate('An_item_was_removed_from_your_basket') as string);
    this.props.RemoveItemFromBasket(payload);
  };

  public render(): JSX.Element {
    const outsideDeliveryZone: boolean = Routes.OutsideDeliveryZone(this.props.Restaurant);

    const menu = this.findMenu();

    return (
      <MainLayout>
        <div className="container-fluid" style={{ paddingBottom: '100px' }}>
          <Menu
            vrid={this.props.params.vrid}
            menu={menu}
            HandleClickItem={this.handleClickItem}
            RemoveItemAt={this.handleRemoveItem}
            AddItemToBasket={this.handleAddItem}
            Basket={Empty}
            Restaurant={this.props.Restaurant}
            ExpandedState={this.props.ExpandedState}
            InitializeExpandedState={this.props.InitializeExpandedState}
            AddToExpandedState={this.props.AddToExpandedState}
            RemoveFromExpandedState={this.props.RemoveFromExpandedState}
            translate={this.props.translate}
            Languages={this.props.Languages}
            InsideDeliveryZone={!outsideDeliveryZone}
            AppDesignScheme={this.props.AppDesignScheme}
            isDark={this.props.isDark}
          />
        </div>
      </MainLayout>
    );
  }
}

const mapStateToProps = (state: Store.State, ownProps: Routes.Routes) => {
  return {
    MenuData: state.flipdish.MenuData,
    Restaurant: Routes.FindRestaurant(state, ownProps),
    ExpandedState: state.flipdish.ExpandedStates[ownProps.params.vrid],
    translate: getTranslate(state.locale),
    Languages: state.locale.languages,
    AppDesignScheme: state.appDesignScheme,
    isDark: state.flipdish.isDark,
    CollectionSummaries: state.flipdish.CollectionSummaries,
    DeliverySummaries: state.flipdish.DeliverySummaries
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<Store.State, {}, Action>) => {
  return {
    AddItemToBasket: (payload: BasketControl.Item) => {
      dispatch(Actions.AddToBasket(payload));
    },
    RemoveItemFromBasket: (payload: { menuId: number; index: number }) => {
      dispatch(Actions.RemoveFromBasket(payload));
    },

    LoadRestaurant: (routes: Routes.Routes) => {
      dispatch(Actions.LoadRestaurant(routes));
    },

    AddToast: (message: string) => {
      dispatch(Actions.AddToast(message));
    },

    InitializeExpandedState: (vrid: number, expandedState: number[]) => {
      dispatch(Actions.InitializeExpandedState(vrid, expandedState));
    },

    AddToExpandedState: (vrid: number, menuSectionId: number) => {
      dispatch(Actions.AddToExpandedState(vrid, menuSectionId));
    },

    RemoveFromExpandedState: (vrid: number, menuSectionId: number) => {
      dispatch(Actions.RemoveFromExpandedState(vrid, menuSectionId));
    }
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MenuContainer);
